import React from "react";
import PropTypes from "prop-types";
import { formValueSelector, Field } from "redux-form";
import { connect } from "react-redux";
import { Check } from "MODULES/shared/components/Forms";
import { toggle } from "MODULES/shared/decorators";
import AddressFields from "../AddressFields";

const ToggleAddressFields = toggle(AddressFields);

export function PhysicalAddress({ sameAsBilling, country }) {
  return (
    <div>
      <div className="form-group">
        <div className="btn-group" data-toggle="buttons">
          <Field
            name="same_as_billing"
            component={Check}
            label="Same as billing address"
          />
        </div>
      </div>
      <ToggleAddressFields
        path="physical_address"
        country={country}
        formName="createCompany"
        open={!sameAsBilling}
      />
    </div>
  );
}

PhysicalAddress.propTypes = {
  sameAsBilling: PropTypes.bool.isRequired,
  country: PropTypes.string
};

const selector = formValueSelector("createCompany");

export default connect(state => ({
  sameAsBilling: selector(state, "same_as_billing"),
  country: selector(state, "physical_address.country")
}))(PhysicalAddress);



// WEBPACK FOOTER //
// ./app/modules/companies/components/CreateCompany/PhysicalAddress.jsx